import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import type { AuthUser } from "../lib/auth";
import {
  trackPremiumPromotionSelect,
  trackPremiumPromotionSkip,
  trackPremiumPromotionView,
} from "../lib/analytics";
import type { PremiumPromotion } from "../lib/promotion";
import { useScrollLock } from "../lib/scrollLock";
import { ROUTES } from "../routes/paths";
import { PremiumPromotionLanding } from "./PremiumPromotionLanding";
import styles from "./StartupPremiumPromotion.module.css";

interface StartupPremiumPromotionProps {
  promotion: PremiumPromotion;
  user: AuthUser;
  onClose: () => void;
}

export function StartupPremiumPromotion({
  promotion,
  user,
  onClose,
}: StartupPremiumPromotionProps) {
  const navigate = useNavigate();
  useScrollLock(true);

  useEffect(() => {
    trackPremiumPromotionView(promotion.campaignId, promotion.productCode);
  }, [promotion.campaignId, promotion.productCode, user.id]);

  return (
    <div className={styles.overlay} role="dialog" aria-modal="true" aria-label="Premium promotion">
      <div className={styles.dialog}>
        <PremiumPromotionLanding
          presentation="modal"
          promotion={promotion}
          onExpire={onClose}
          onExit={() => {
            trackPremiumPromotionSkip(promotion.campaignId, promotion.productCode);
            onClose();
          }}
          onContinue={() => {
            trackPremiumPromotionSelect(promotion.campaignId, promotion.productCode);
            onClose();
            navigate(ROUTES.SUBSCRIPTIONS.ATOM({
              productCode: promotion.productCode,
              checkout: true,
            }));
          }}
        />
      </div>
    </div>
  );
}

export default StartupPremiumPromotion;
